import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { Box, Collapse, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';

import { UsOnlyPill } from '../../../components/_mui';
import {
  SUPPLIER_LOCK_BANNER_LEAD,
  SUPPLIER_LOCK_BANNER_TAIL,
  SUPPLIER_LOCK_FALLBACK_NAME,
} from '../../../constants/marketplace';
import { ISupplierLock } from '../../../types/marketplace';

interface IProps {
  lock: ISupplierLock | null;
}

const bannerSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: 1.5,
  mt: 2,
  py: 1.5,
  px: 2,
  borderRadius: 1,
  border: ({ palette }) => `1px solid ${alpha(palette.primary.main, 0.5)}`,
  backgroundColor: ({ palette }) => alpha(palette.primary.main, 0.04),
};

const iconSx: SxProps<Theme> = { fontSize: 22, color: 'primary.main', flexShrink: 0 };

const textSx: SxProps<Theme> = { flex: '1 1 240px', minWidth: 0, textWrap: 'pretty' };

const nameSx: SxProps<Theme> = { fontWeight: 'medium' };

const pillSlotSx: SxProps<Theme> = { ml: 'auto' };

export const SupplierLockBanner: React.FC<IProps> = ({ lock }) => {
  const { transitions } = useTheme();

  // Kept through the collapse so the text does not blank out while the banner closes.
  const [shownName, setShownName] = useState<string | undefined>(lock?.name);

  useEffect(() => {
    if (lock) {
      setShownName(lock.name);
    }
  }, [lock]);

  return (
    <Collapse
      in={!!lock}
      timeout={transitions.duration.enteringScreen}
      easing={transitions.easing.easeInOut}
      unmountOnExit
    >
      <Box role="status" sx={bannerSx}>
        <LocalShippingOutlinedIcon aria-hidden sx={iconSx} />
        <Typography variant="body2" color="text.primary" sx={textSx}>
          {SUPPLIER_LOCK_BANNER_LEAD}{' '}
          <Box component="span" sx={nameSx}>
            {shownName || SUPPLIER_LOCK_FALLBACK_NAME}
          </Box>
          {SUPPLIER_LOCK_BANNER_TAIL}
        </Typography>
        <Box component="span" sx={pillSlotSx}>
          <UsOnlyPill />
        </Box>
      </Box>
    </Collapse>
  );
};
